import { useEffect, useRef } from "react";

/**
 * beforeunload 처리
 * @param callback
 * @param state
 */
const useBeforeUnload = (
  callback: (e: BeforeUnloadEvent) => void,
  dependencies: any
) => {
  const saveCallback = useRef<any>(callback);

  useEffect(() => {
    saveCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    window.addEventListener("beforeunload", saveCallback.current, true);

    return () => {
      window.removeEventListener("beforeunload", saveCallback.current, true);
    };
  }, [saveCallback, ...dependencies]);
};

export default useBeforeUnload;
